// CONSTANTS are all caps.
const NS = 'SiteHeader';
const CLS = 'siteHeader';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rSiteHeader from './SiteHeader.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';
import * as Api from '../../../../global/js/api';
import _ from 'lodash';
import {timeout} from 'q';

export class SiteHeader {
	constructor($el) {
		// $el is the blk node return by the loadSiteHeader function
		this.$el = $el;
		this.textInput = document.getElementById('siteSearch');
	}

	init() {
		this.setSiteHeader();
		const $blk = $(this.$el);
		if($blk.data('sticky')) {
			window.onscroll = () => {
				this.siteHeaderScroll();
			};
		}
	}

	siteHeaderScroll() {
		// console.log('zenmeshuo');
		let header = this.$el;
		let sticky = header.offsetTop;

		if (window.pageYOffset > sticky) {
			header.classList.add('sticky');
			$('main').addClass('scrollPadding');
		} else {
			header.classList.remove('sticky');
			$('main').removeClass('scrollPadding');
		}
	}

	setSiteHeader() {
		const $blk = $(this.$el);
		const This = this;
		const delay = 500;
		let searchIcon = $('.navbarSearch');
		let pcCloseIcon = $blk.find(BLK + 'pcSearchPanel .icon-close');
		let menu = $('.siteHeader-menu');

		$(`${BLK}topbar-item`).on('click', (e) => {
			$(e.currentTarget).siblings(`${BLK}topbar-item`).removeClass('active');
			$(e.currentTarget).addClass('active');
		});

		menu.on('click', () => {
			$('.navbarSearchPanel').removeClass('show');
			searchIcon.attr('aria-expanded', 'false');
			setTimeout(()=> {
				this.toggleFixedBody();
			}, delay);
		});

		searchIcon.on('click', (e) => {
			$('.navbarCollapse').collapse('hide');
			menu.attr('aria-expanded', 'false');
			$('.navbarSearchPanel').toggleClass('show');
			searchIcon.attr('aria-expanded', function(i, attr) {
				return attr == 'true' ? 'false' : 'true';
			});

			$(`${BLK}pcSearchPanel`).toggleClass('show');
			setTimeout(()=> {
				this.toggleFixedBody();
			}, delay);
			// if(!$blk.data('sticky')) {
			// 	if ($('.navbarSearchPanel').hasClass('show')) {
			// 		This.fixCollapsedElementsAndHeader();
			// 	} else {
			// 		This.unfixCollapsedElementsAndHeader();
			// 	}
			// }
		});

		pcCloseIcon.on('click', (e) => {
			$(`${BLK}pcSearchPanel`).toggleClass('show');
			setTimeout(()=> {
				this.toggleFixedBody();
			}, delay);
		});

		// listen to input changes and debounce them to avoid calling
		// the api excessively
		$blk.find('.site-search-input').on('input', _.debounce(This.getSearchResults.bind(This), 300));

		// listen to  collapse events
		// if($blk.data('sticky')) {
		// 	This.fixCollapsedElementsAndHeader();
		// } else {
		// 	$blk.find(`.${CLS}-mobile`).each(function() {
		// 		$(this).find('.navbar-collapse').on('shown.bs.collapse', () => {
		// 			This.fixCollapsedElementsAndHeader();
		// 		});

		// 		$(this).find('.navbar-collapse').on('hidden.bs.collapse', () => {
		// 			if (!$('.navbarSearchPanel').hasClass('show')) {
		// 				This.unfixCollapsedElementsAndHeader();
		// 			}
		// 		});
		// 	});
		// }

		this.initDropdown();

		this.toggleFixedBody();

		$(window).on('resize', (e)=> {
			setTimeout(()=> {
				this.toggleFixedBody();
			}, delay);
		});
	}

	// fixCollapsedElementsAndHeader() {
	// 	// const $blk = $(this.$el);
	// 	// let h = $blk.outerHeight(true);

	// 	// $(`.${CLS}-mobile .navbar-collapse`).attr('style', 'top: ' + h + 'px !important;');

	// 	// $blk.addClass('fixedState');

	// 	// $('body').attr('style', 'padding-top: ' + h + 'px;');
	// }

	// unfixCollapsedElementsAndHeader() {
	// 	// const $blk = $(this.$el);
	// 	// $blk.removeClass('fixedState');
	// 	// $('body').attr('style', '');
	// }

	initDropdown() {
		const $blk = $(this.$el);
		$blk.find('.menuItem-wrapper').hover( function() {
			$(this).find('.dropdown-menu-custom').toggleClass('show');
		});
	}

	getSearchResults(e) {
		const This = this;
		let searchField = $(e.target);
		let searchWrapper = searchField.closest('.site-search-wrapper');
		let resultsContainer = searchWrapper.find('ul');
		let searchTerm = searchField.val();
		let loadingImage = searchWrapper.find('.loading-image');

		if (searchTerm.length < 3) {
			resultsContainer.addClass('d-none');
			return;
		}

		const $blk = $(this.$el);
		loadingImage.removeClass('d-none');

		This.getsearchResultsCall(searchTerm).then((data) => {
			if (Api.isSuccessful(data)) {
				// successful call and status
				let res = data.hits || [];
				if (res.length > 0) {
					// found results, iterate and construct the list
					let endpoint = $blk.data('searchPage');
					resultsContainer.removeClass('d-none');
					resultsContainer.empty();
					for (let i = 0; i < res.length; i++) {
						let result = res[i];
						resultsContainer.append(`
							<li onclick="location.href='${endpoint}?keyword=${encodeURIComponent(result.query)}';">${result.query}</li>
						`);
					}
				} else {
					// show a not-found message
					resultsContainer.addClass('d-none');
				}
			}
			loadingImage.addClass('d-none');
		}).catch((error) => {
			// call failed
			resultsContainer.append(`
				<li class="no-result">There was an error.</li>
			`);
			loadingImage.addClass('d-none');
		});
	}

	getsearchResultsCall(searchTerm) {
		if (!searchTerm || searchTerm == '') return;

		const $blk = $(this.$el);
		let endpoint = $blk.data('searchEndpoint');
		return Api.getApi(endpoint + '?prefix=' + encodeURIComponent(searchTerm) + '&size=5');
	}

	toggleFixedBody() {
		const $body = $('body');
		const $html = $('html');
		const iOSBrowser = navigator.userAgent.match(/iPhone|iPad/i);
		if ($(window).width() <= 991) {
			if ($('.navbar-collapse').hasClass('show')) {
				if (iOSBrowser) $html.addClass('fixed');
				$body.addClass('fixed');
			} else {
				if (iOSBrowser) $html.removeClass('fixed');
				$body.removeClass('fixed');
			}
		} else {
			if (iOSBrowser) $html.removeClass('fixed');
			$body.removeClass('fixed');
		}
	}
	// Add more functions like on above here
}
